/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_TitleInputs */

const es_components_buy_messages_modal_custom_title = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad personalizada`)
};

const en_components_buy_messages_modal_custom_title = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom amount`)
};

/**
* | output |
* | --- |
* | "Custom amount" |
*
* @param {Components_Buy_Messages_Modal_Custom_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_title = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_title(inputs)
	return en_components_buy_messages_modal_custom_title(inputs)
});
export { components_buy_messages_modal_custom_title as "components.buy_messages_modal.custom.title" }